import apiService from 'services/apiService';

export async function register (email) {
  const { data } = await apiService.request('/accounts/register/', {
    method: 'POST',
    body: JSON.stringify({
      email,
    }),
  });

  if (data.id) return data;

  const { data: { results: [existingUser] } } = await apiService.request(`/user/?email=${email}`);
  return existingUser;
}

export default register;



// WEBPACK FOOTER //
// ./src/helpers/accountsHelpers.js